import { Doughnut } from 'react-chartjs-2';
import { Chart, ChartData, ChartOptions, ArcElement, Tooltip, Legend} from "chart.js";
import { StatsChartData } from 'models/StatisticChart';
import LegendCustom from '../Components/LegendCustom';

Chart.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({labels, datasets}:StatsChartData) => {

    const chartData: ChartData<'doughnut'> = {
        labels,
        datasets
    }

    const chartOptions: ChartOptions<'doughnut'> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                display: false,
                labels: {
                    generateLabels: (chart) => {                 
                            const { labels, datasets } = chart.data;
                            if (labels && datasets.length) {
                                return labels.map((label, i) => {
                                    const backgroundColor = Array.isArray(datasets[0].backgroundColor) ? datasets[0].backgroundColor[i] as string : 'transparent'
                                    return {
                                        text: `${label} (${datasets[0].data[i] as number})`,
                                        fillStyle: backgroundColor,
                                        strokeStyle: backgroundColor,
                                        hidden: false,
                                        index: i,
                                        lineWidth: 1
                                    }
                                });
                            }
                        return [];
                    }
                }
            }
        }
    }

    const mergedDataset = labels.map((label, i) => {
        const backgroundColor = Array.isArray(datasets[0].backgroundColor) ? datasets[0].backgroundColor[i] as string : 'transparent';
        return {
            label: `${label} (${datasets[0].data[i] as number})`,
            backgroundColor: backgroundColor,
            borderColor: backgroundColor
        } 
    });

    return (
        <div className='row mb-4'>
                <div className="col-md-8">
                    <div style={{width: '100%', height: '300px'}}>
                        <Doughnut data={chartData} options={chartOptions} />
                    </div>
                </div>
                <div className="col-md-4">
                    <LegendCustom datasets={mergedDataset} />
                </div>
            </div>
    );
}

export default DoughnutChart;